import type { IUserProjectService } from "./IUserProjectService";
import type {
    ApiReturnProject,
    ApiUserProject,
    ApiReturnUserProject,
} from "@highimpact-frontend/api-types";
import { api_config } from "../../../api-commons";


class UserProjectService implements IUserProjectService {
    async get(userId: number): Promise<ApiReturnProject[]> {
        const response = await api_config.get(`/users/${userId}/projects`);
        return response.data;
    }

    async getUsersProjectsByUserIdOrByProjectId(userId?: number, projectId?: number): Promise<ApiReturnUserProject[]> {
        const searchParams = new URLSearchParams();
        if (userId !== undefined) {
            searchParams.append('user_id', userId.toString());
        }
        if (projectId !== undefined) {
            searchParams.append('project_id', projectId.toString());
        }
        const response = await api_config.get(`/users/projects?${searchParams.toString()}`);
        return response.data;
    }

    async add(params: ApiUserProject): Promise<ApiReturnUserProject> {
        const response = await api_config.post(`/users/${params.user_id}/projects/${params.project_id}?is_admin=${params.is_admin}`);
        return response.data;
    }
    async update(params: ApiUserProject): Promise<ApiReturnUserProject> {
        const response = await api_config.put(`/users/${params.user_id}/projects/${params.project_id}?is_admin=${params.is_admin}`);
        return response.data;
    }

    async delete(params: ApiUserProject): Promise<ApiReturnUserProject> {
        const response = await api_config.delete(`/users/${params.user_id}/projects/${params.project_id}`);
        return response.data;
    }
}

const instance = new UserProjectService();
export default instance;